<template>
  <div>
    <div class="flex justify-between">
      <label
        v-if="label"
        v-text="label"
        :for="$id('currency-input')"
        class="block text-sm font-medium leading-5 text-gray-700"
      />
      <span v-if="cornerHint" class="text-sm leading-5 text-gray-500" v-text="cornerHint"></span>
    </div>

    <div class="mt-1 relative rounded-md shadow-sm">
      <currency-input
        :id="$id('currency-input')"
        v-bind="$attrs"
        v-on="$listeners"
        :class="{'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red': hasError}"
        class="form-input block w-full sm:text-sm sm:leading-5 disabled:opacity-50 disabled:bg-gray-100"
      />

      <slot />
    </div>

    <p class="mt-2 text-sm text-red-600" v-if="hasError" v-text="error[0]" />
  </div>
</template>

<script>
import { CurrencyInput } from "vue-currency-input";

export default {
  components: { CurrencyInput },

  inheritAttrs: false,

  props: {
    label: {
      required: false,
      type: String
    },
    cornerHint: {
      required: false,
      type: String
    },
    error: {
      required: false,
      default: null
    }
  },

  computed: {
    hasError() {
      return !!this.error;
    }
  }
};
</script>